export default "__VITE_ASSET__3966e1ae__"